import React from 'react'
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap'

export default class LanguageSelect extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dropdownOpen: false
        }
        this.flags = {
            en: "data:image/gif;base64,R0lGODlhEQAMALMAAOO9wrKAltra55+qzws6mWSFxjBgtbvR797r+v/18PiPge21rN8tHeZoXvfDvvfQzSH5BAAAAAAALAAAAAARAAwAAARpsDlEKhlsWNLaCo1yGBWmEUagJAdReIlmph1SWEaYIAIjgIsEyQB4FBeOx4PhSCoBUIZ0Sq1ar1Zo8dF0MLkLowMwTCwagZ4AkVA0SJUCohMwmC4JR+N2aNdLGRUGB24BZw0bdxYIDw0RADs=",
            ro: "data:image/gif;base64,R0lGODlhEQAMAJEAAAgAtcYAAP//AAAAACH5BAAAAAAALAAAAAARAAwAAAIihC+ZwX2oRHMPRDlDtTHrenlbmI1dCZ6TqYhpiz7k+i5ZAQA7",
            it: "data:image/gif;base64,R0lGODlhEQAMAJEAAAC1AMYAAPf39wAAACH5BAAAAAAALAAAAAARAAwAAAIihC+ZwX2oRHMPRDlDtTHrenlbmI1dCZ6TqYhpiz7k+i5ZAQA7",
            es: "data:image/gif;base64,R0lGODlhEQAMALMAAP//AMocLsMAIMYLHv//EscSMM4sPaRXGdXFItatNtnrGryDCefRDeTiCXdESMOmcSH5BAAAAAAALAAAAAARAAwAAARC0IRJq5Uj681DEWAojgUBnGiqEuaJHIuasiezHA8inzSQHI5HYgfoIRaOw3DXUzQQDAWR8BlZQ4UAZ7sJSCxgiiECADs=",
            fr: "data:image/gif;base64,R0lGODlhEQAMAJEAAAgAtcYAAPf39wAAACH5BAAAAAAALAAAAAARAAwAAAIihC+ZwX2oRHMPRDlDtTHrenlbmI1dCZ6TqYhpiz7k+i5ZAQA7",
            de: "data:image/gif;base64,R0lGODlhEQAMAJEAAAAAAP/WAMYAAAAAACH5BAAAAAAALAAAAAARAAwAAAIXhI+py+1vhJy02ouz3jL4D4biSJbm6RUAOw=="
        }
    }

    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        })
    }

    languages = () => {
       return  this.props.languages.map(l => {
            return (
                <div key={l.locale} className={'px-2 py-1'}>
                    <a className={'small'} href={l.href}>
                        <img src={this.flags[l.locale]}
                            className="align-top mt-1 mr-2" />
                        {l.text}
                    </a>
                </div>
            )
        })
    }

    render() {
        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} size={'sm'} id="localeSwitch">
                <DropdownToggle
                    tag="span"
                    onClick={this.toggle}
                    data-toggle="dropdown"
                    aria-expanded={this.state.dropdownOpen}
                    style={{cursor: 'pointer'}}
                    className={'small text-nowrap text-primary'}
                    caret
                >
                    <img src={this.flags[this.props.language]}
                         className="align-top mt-1 mr-2" />
                    {this.props.language.toUpperCase()}
                </DropdownToggle>
                <DropdownMenu right>
                    {this.languages()}
                </DropdownMenu>
            </Dropdown>
        )
    }
}